import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

// Async thunk for login
export const login = createAsyncThunk("providerAuth/login", async (FormData, thunkAPI) => {
    try {
        const res = await axios.post(
            `${BACKEND_URL}/provider/login`,
            FormData
        );
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Login failed");
    }
});

export const signup = createAsyncThunk("providerAuth/signup", async (FormData, thunkAPI) => {
    try {
        const res = await axios.post(
            `${BACKEND_URL}/provider/signup`,
            FormData
        );
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Login failed");
    }
});

// Forgot Password Thunk
export const forgotPassword = createAsyncThunk(
  "providerAuth/forgotPassword",
  async (email, thunkAPI) => {
    try {
      const res = await axios.post(`${BACKEND_URL}/provider/forgot-password`, { email });
      return res.data.message || "Reset link sent.";
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.error || "Something went wrong");
    }
  }
);

// Reset Password Thunk
export const resetPassword = createAsyncThunk(
  "providerAuth/resetPassword",
  async ({ token, newPassword }, thunkAPI) => {
    try {
      const res = await axios.post(`${BACKEND_URL}/provider/reset-password`, {
        token,
        newPassword,
      });
      return res.data.message || "Password reset successful!";
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.error || "Reset failed");
    }
  }
);


export function saveTokenInLocalStorage(access_token, expires_in) {
    // console.log("access_token", access_token);
    // console.log("expires_in", expires_in);
    const expiryTime = new Date().getTime() + expires_in * 1000;
    localStorage.setItem("provider_access_token", access_token);
    localStorage.setItem("provider_token_expiry", expiryTime);
}

const authFromStorage = localStorage.getItem("provider_access_token");
const authSlice = createSlice({
    name: "providerAuth",
    initialState: {
        auth: authFromStorage ? { access_token: authFromStorage } : null,
        loading: false,
        error: null,
    },
    reducers: {
        logout: (state) => {
          state.auth = null;
          state.loading = false;
          state.error = null;

          localStorage.removeItem("provider_access_token");
          localStorage.removeItem("provider_token_expiry");
          localStorage.removeItem("user_id");
          localStorage.removeItem("user_name");
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.loading = false;
                state.auth = action.payload;
                state.error = null;
            })
            .addCase(login.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Forgot Password
            .addCase(forgotPassword.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(forgotPassword.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(forgotPassword.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Reset Password
            .addCase(resetPassword.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(resetPassword.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(resetPassword.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
        },
});

export const { logout } = authSlice.actions;
export const selectProviderAuth = (state) => !!state.providerAuth.auth;
export default authSlice.reducer;
